<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>

<!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>-->
<!--    <header-home-two :custCare="customerCare" :menuItems="navs" :side="SideMenu" :titleWordd="titleWord"-->
<!--                     @toggleSidebar="toggleSidebar"/>-->


    <section id="testimonial" class="appie-testimonial-2-area">
      <div class="container " v-if="!showloading">
<!--        <BackButton/>-->
        <div class="row">
          <div class="col-md-3 whitebackground menudiv" >
            <menubar @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"
                     :menuItems="navs"/>
          </div>
          <div class="col-md-9  graybackground contentdiv" >
            <div class="col-lg-12 mt-2">
              <div>
                <Commonprofile/>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div style="text-align: center"  class="mt-2">
                    <span v-html="title"></span>
                    <span class="badge rounded-pill bluebackground" style=";margin: 0px 6px"
                          v-html="countView.title"></span>

                  </div>
                  <!--            <center><span v-html="title" :style="{textSizeAdjust:textSize}"></span></center>-->
                  <!--            <center>-->
                  <!--            <span class="badge rounded-pill " style="background-color: red;"><span v-html="countView.title" :style="{backgroundColor:bgColor}"></span></span>-->
                  <!--            </center>-->
                  <br>
                  <div>
                    <div v-if="list.length > 0" class="row">
                      <!--                {{countView}}-->
                      <!--                {{list.length}}-->
                      <div v-for="(ListData,indexmain) in list" :key="indexmain" class="col-12 col-md-6 "
                           style="margin-bottom: 10px">
                        <!--                  {{ListData.id}}-->
                        <div class="card" style="width: 100%;border-radius: 10px!important;" >
                          <div class="card-body p-2 ">
                            <span class="badge endbadge">{{ ListData.jobType }}</span>
                            <div class="row mt-2" @click="WaitingFullFunc(ListData.url)">
                              <div class="col-2 col-md-2 col-lg-2 automargin" >
                                <img :alt="ListData.title" :src="ListData.image" class="logoimageSize">
                              </div>
                              <div class="col-10 col-md-10 col-lg-10 textleft">
                                <div class="row">
                                <p v-html="ListData.employer"></p>
                                <!--                          <p v-html="ListData.joblocation"></p>-->
                                  <span><i class="fas fa-map-marker-alt" aria-hidden="true" style="color: #5E5E5E"></i> <span  style="color: #EE3169 !important;" v-html="truncatedJobLocation(ListData.joblocation)"></span></span>
                                  <p class="" v-html="ListData.jobtitle"></p>
                                <p>
                            <span class="badge rounded-pill " style="background-color: #4D5BE1;"><span
                                v-html="ListData.noofvancancy"></span></span>
                                </p>
                                </div>
                                <hr class="linestyle">
                                <div class="row" @click="WaitingFullFunc(ListData.url)" >
                                  <div class="col-6 col-sm-6 col-lg-6">

                                    <p><span v-html="ListData.starting"></span></p>

                                  </div>
                                  <div class="col-6 col-sm-6 col-lg-6">

                                    <p><span v-html="ListData.ending"></span></p>

                                  </div>
                                </div>



                              </div>



                            </div>
                            <div class="row">
                            <div class="col-2 col-md-2 col-lg-2 " >
                            </div>
                            <div class="col-10 col-md-10 col-lg-10 textleft">
                              <div class="row mt-1">
                                <div v-for="(ListDatabutton,index) in ListData.button" :key="index" class="col-12 col-md-6 "
                                     style="margin: auto;">
                                  <div v-if="ListDatabutton.visible == '1'">
                                    <div v-if="index == 0">
                                      <button class="fontunset" @click="action(ListDatabutton.activity,ListDatabutton.url)"
                                              :style="{backgroundColor:'#602FEA',border:'unset !important',width:'100%',borderRadius:'5px',height :'40px',color:'white !important'}" type="button">
                                <span v-html="ListDatabutton.title">
                                </span></button>
                                    </div>
                                    <div v-else>
                                      <div  class="" @click="isactive(ListDatabutton.onChange,indexmain)"
                                            :style="{backgroundColor:ListDatabutton.option[ListData.value == 0 ? 0 : 1].bgColor,border:'unset !important',width:'100%',borderRadius:'3px',textAlign:'center'}" type="button">

                                        <span v-html="ListDatabutton.option[ListData.value == 0 ? 0 : 1].title" style="padding-right: 4px;"></span>
                                        <img :src="ListData.value == 0 ? active : inactive" style="width: 40px !important;height: 40px !important;">
                                      </div>


                                      <!--                                  </div>-->


                                      <!--                                <b-form-checkbox v-model="checked" switch>-->
                                      <!--                                  Switch Checkbox <b>(Checked: {{ checked }})</b>-->
                                      <!--                                </b-form-checkbox>-->

                                      <!--                              </div>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                            </div>
                            </div>

                            <!--                      {{ListData.image}}-->
                            <!--                        <center>-->
                            <!--                          <span v-if="ListTitleData.visible === '1'" class="badge rounded-pill bg-secondary" v-html="ListTitleData.title"></span>-->
                            <!--                          <span v-if="ListData.active === '1'" style="color: green;float: inline-end;">✔</span>-->
                            <!--                          <span v-else style="color: red;float: inline-end;">X</span>-->
                            <!--                        </center>-->
                            <!--                      </div>-->

                            <!--                      <br>-->
                            <!--                      <div class="container">-->
                            <!--                        <table style="width: 100%">-->
                            <!--                          &lt;!&ndash;                      <div >&ndash;&gt;-->
                            <!--                          <tr v-for="(SubListData,index) in ListData.list" :key="index">-->
                            <!--                            <th v-html="SubListData.title" :style="{color:SubListData.bgColor}"></th>-->
                            <!--                            <td v-html="SubListData.content" ></td>-->
                            <!--                          </tr>-->

                            <!--                          &lt;!&ndash;                      </div>&ndash;&gt;-->
                            <!--                        </table>-->
                            <!--                        <br>-->
                            <!--                        <div class="row">-->
                            <!--                          <div class="col-6 col-lg-6 col-md-6">-->
                            <!--                            <span v-html="ListData.card[0].title"></span>-->
                            <!--                          </div>-->
                            <!--                          <div class="col-6 col-lg-6 col-md-6">-->
                            <!--                            <span v-html="ListData.card[1].title"></span>-->
                            <!--                          </div>-->
                            <!--                        </div>-->
                            <!--                      </div>-->
                            <!--                      <br>-->
                            <!--                      <div v-for="(ListButtonData,index) in ListData.button" :key="index">-->
                            <!--                        &lt;!&ndash;                      {{ListButtonData}}&ndash;&gt;-->
                            <!--                        <center>-->
                            <!--                          <a :href="ListData.invoice_pdf">-->
                            <!--                            <button type="button" class="btn" :style="{backgroundColor:ListButtonData.bgColor}" v-html="ListButtonData.title"></button>-->
                            <!--                          </a>-->
                            <!--                        </center>-->

                            <!--                      </div>-->


                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="card">
                        <div class="card-body" style="text-align: center">


                          <h5><span style="color: blue">Data Not</span> <span style="color: red;">Found!</span></h5>
                          <span style="color: black;font-weight: 800;">நீங்கள் தேடிய தகவல் தற்போது இல்லை</span>
                          <br>
                          <br>
                          <!--                    <button type="button" @click="navigateToSamePage" class="btn btn-success">Exit</button>-->


                        </div>
                      </div>
                    </div>
                    <span v-if="loading" style="text-align: center"> loading...</span>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>



      </div>


      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue">
          <div class="row">
            <!-- First Card Row -->
            <div v-for="(customerCareData,index) in customerCare" :key="index" class="col-12 col-lg-12 col-md-12 mb-4">
              <span v-html="customerCareData.label"></span>


              <div class="card" >
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i aria-hidden="true" class="fa fa-phone flipped" style="background: white;"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>


    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>

  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'


// import HeaderHomeTwo from '../HomePage/Header.vue'

import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";
// import BackButton from '../HomePage/BackButton.vue';

import LoaderAppie from '../LoaderAppie.vue'
// import { BFormCheckbox } from 'bootstrap-vue'
import active from "@/assets/images/switch-on.png";
import inactive from "@/assets/images/switch-off.png";
// import SidebarHomeOne from "@/components/HomeOne/SidebarHomeOne.vue";
import Commonprofile from "@/components/HomePage/commonprofilediv.vue";
import Menubar from "@/components/HomePage/menu.vue";

export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    Menubar, Commonprofile,
    // SidebarHomeOne,

    LoaderAppie,
    // BackButton,
    // HeaderHomeTwo,
    // BFormCheckbox,

  },
  data() {
    return {
      maxLength:45,
      loading:false,
      isFetchingData: false,
      lastId:0,
      active:active,
      inactive:inactive,
      isactiveValue:0,
      checked:false,
      showloading:false,
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      title: '',
      textSize: '',
      countView: [],
      list: [],
      ListTitleData: [],
      ListButtonData: [],
      bgColor: '',
      template: '',
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            // {
            //   // name:'Home 5',
            //   name: 'Change Mobile Number',
            //   path: '/home-five'
            // },
            // {
            //   name:'Home 6',
            //   path:'/home-six'
            // },
            // {
            //   name:'Home 7',
            //   path:'/home-seven'
            // },
            // {
            //   name:'Home 8',
            //   path:'/home-eight'
            // },
          ],
        },
        // {
        //   name:'service',
        //   path:'/service-details'
        // },
        // {
        //   name:'pages',
        //   childrens:[
        //     {
        //       name:'About us',
        //       path:'/about-us'
        //     },
        //     {
        //       name:'Error',
        //       path:'/error'
        //     }
        //   ],
        // },
        // {
        //   name:'news',
        //   childrens:[
        //     {
        //       name:'News',
        //       path:'/news'
        //     },
        //     {
        //       name:'Single news',
        //       path:'/single-news'
        //     },
        //   ],
        // },
        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },

      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },
  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },

  async created() {
    this.showloading=true;
    if (this.$route.query.page) {
      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);
      this.modifiedString = decryptedString;

      try {
        const PaymentHistoryData = await callAxiosWithConfig(this.modifiedString, {'lastId': 0, 'listSize': 0}, 'post');
        // console.log(PaymentHistoryData);
        this.title = PaymentHistoryData.title;
        // console.log(this.title)

        this.countView = PaymentHistoryData.countView;
        this.list = PaymentHistoryData.list;

        this.showloading=false;

        if (PaymentHistoryData.list.length > 0) {
          // this.isactiveValue = PaymentHistoryData.list[0].value == 0 ? 0 : 1;
          this.lastId = PaymentHistoryData.list[PaymentHistoryData.list.length - 1].id;
        }


        this.textSize = PaymentHistoryData.textSize;


        this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
        this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
        this.customerCare = JSON.parse(localStorage.getItem("customerCare"));

        // console.log(this.SideMenu)
        this.$emit("tempData", this.SideMenu);
        this.$emit("title", this.titleWord);
        this.$emit("customerCare", this.customerCare);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle 401 status silently
          // For example, do nothing or log a message without displaying it
        } else {
          // Handle other errors by displaying them
          console.error('Error in Axios request:', error);
        }
      }
    }

    // this.encryptedParam = this.$route.query.page;
    //
    // this.decryptedValue = this.Decrypt(this.encryptedParam);
    // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    // console.log(this.modifiedString)
    // alert(this.modifiedString)



    window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    async handleScroll() {
      if (this.isFetchingData) {
        // alert(this.isFetchingData)
        return;
      }
      // Check if the user has scrolled to the bottom of the page
      const distanceToBottom = document.documentElement.scrollHeight - (window.innerHeight + window.scrollY);
      if (distanceToBottom < 100) {
        this.isFetchingData = true;
        this.loading=true;
        const loadmoreData = await callAxiosWithConfig(this.modifiedString, {'lastId': this.lastId, 'listSize': 0}, 'post');

        // console.log(loadmoreData)
        if (loadmoreData.list.length > 0){
          this.list = [...this.list, ...loadmoreData.list];
          // Update the lastId with the id of the last element in the new data
          this.lastId = loadmoreData.list[loadmoreData.list.length - 1].id;
          this.isFetchingData = false;
          this.loading=false;

        }
        else{
          this.loading=false;
        }


      }
    },
//      truncatedJobLocation(location) {
//   if (location.length <= 20) {
//     return location; // If the string length is 20 or less, return the original string
//   } else {
//     return location.substring(0, 20) + "..."; // Otherwise, return the first 20 characters followed by "..."
//   }
// },

truncatedJobLocation(jobLocation) {
      let visibleText = jobLocation.replace(/<[^>]+>/g, ''); // Remove HTML tags
      if (visibleText.length > this.maxLength) {
        let truncatedText = visibleText.substring(0, this.maxLength);
        return truncatedText + '...';
      } else {
        return visibleText;
      }
    },
    async isactive(url,indexvalue){
      const ViewPostData = await callAxiosWithConfig(url, '', 'post');
      // console.log('ViewPostData',ViewPostData);
      if(ViewPostData.status== true){
        this.$set(this.list[indexvalue], 'value', ViewPostData.value);
        // this.isactiveValue = ViewPostData.value == 0?0:1;

      }


    },
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },


    navigateToSamePage() {
      this.$router.go(-1);
    },

    Decrypt(str) {
      return str.replace(/[a-zA-Z]/g, function (char) {
        const charCode = char.charCodeAt(0);
        const decryptedCharCode = charCode - 1; // Decryption logic
        return String.fromCharCode(decryptedCharCode);
      });
    },

    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },


    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },

    async WaitingFullFunc(url) {
      const encryptedString = this.encryptUrl(url);

      await this.$router.push(`/post-view?page=${encodeURIComponent(encryptedString)}`);
    },
    async action(activity, url) {
      // alert(activity)
      // alert(url)
      const inputString = activity;
      const lastPart = inputString.split('.').pop();

      this.urlData = url;
      if (lastPart === 'ViewCandidate_List') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
      }

    },
  }

}
</script>

<style>
.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .temp_10_space {
    margin-bottom: 30px;
  }

  .imageSize {
    width: 10%;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {

}

@media (min-width: 768px) and (max-width: 991px) {

}

/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }

  .imageSize {
    width: 4%;
  }
}
.logoimageSize {
  width: 90%;
  margin: auto !important;
}
.endbadge{
 background-color: #EE3169;position: absolute; top: 0;left: 0;border-radius: 10px 0px 14px 0px !important;
}
.marginauto{
  margin: auto !important;
}
.linestyle{
border-top: 1px dashed #ccc;
  margin: 0!important;
  margin-top: 5px !important;
}
</style>
